var loginForm = document.getElementById('login-modal-form');

if (loginForm) {
    loginForm.addEventListener('submit', processLoginForm);

    var request = new XMLHttpRequest();
    var loginFormError = document.getElementById('login-modal-form-error');

    request.onreadystatechange = function() {
        if(request.readyState === 4) {
            if(request.status === 200) {
                location.reload();
            } else {
                loginFormError.style.display = 'block';
            }
        }
    };
}

function processLoginForm(e) {
    e.preventDefault();
    loginFormError.style.removeProperty('display');

    var usernameInput = document.getElementById('login-modal-form-username');
    var passwordInput = document.getElementById('login-modal-form-password');
    var tokenInput = document.getElementById('login-modal-form-token');

    request.open('Post', loginForm.action);
    request.setRequestHeader('Content-Type', 'application/json');
    request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    request.send(JSON.stringify({
        _username: usernameInput.value,
        _password: passwordInput.value,
        csrf_shop_security_token: tokenInput.value
    }));
}
